module.exports = __webpack_public_path__ + "static/pyohio-talks-2-0f8a6490456736d4c49db5c4ca44723b.jpg";